const visileColumns = [
  {
    title: "Eligibility ID",
    field: "eligibility_id",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Announcement ID",
    field: "announcement_id",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Status",
    field: "status_desc",
    locked: false,
    filter: "text",
    width: "350",
    show: true,
  },
  {
    title: "Job Profile",
    field: "profilername",
    locked: false,
    filter: "text",
    width: "350",
    show: true,
  },
  {
    title: "Position Title",
    field: "PositionTitle",
    locked: false,
    filter: "text",
    width: "350",
    show: true,
  },
  {
    title: "General Availibility Ids",
    field: "GeneralAvailibilityIds",
    locked: false,
    filter: "text",
    width: "350",
    show: true,
  },
  {
    title: "Eligibility List est",
    field: "date_requested",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "220",
    show: true,
  },
  {
    title: "Date Executed",
    field: "date_executed",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "180",
    show: true,
  },
  {
    title: "Eligibility List exp",
    field: "date_expires",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "220",
    show: true,
  },
  {
    title: "Ann Open Date",
    field: "start_date",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "180",
    show: true,
  },
  {
    title: "Ann Close Date",
    field: "end_date",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "180",
    show: true,
  },
];

export default visileColumns;
